import { Chip, CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Cancel, InfoOutlined, RotateLeft, ThumbDownAlt, ThumbUp, Update } from "@material-ui/icons";
import { useAuth } from "@airborne/react-admin";
import React, { useEffect, useState } from "react";
import {
  BooleanInput,
  Button,
  SelectArrayInput,
  SelectInput,
  TextInput,
  Toolbar,
  minValue,
  required,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { ExperienceNoteType } from "../../../../../../src/Enums/ExperienceNoteType";
import { CustomDatetime } from "../../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../../Components/SectionTitle";
import { Separator } from "../../../../../Components/Separator";
import { GetCarrierType } from "../../../../../Enums/CarrierType";
import { PbhSvcShipmentTypeEnum } from "../../../../../Enums/PbhSvcShipmentType";
import { ServiceableStatu } from "../../../../../Enums/ServiceableStatus";
import { useAppDataProvider } from "../../../../../dataprovider";
import { PbhRequestServiceablePutModel } from "../../../Models/PbhRequestServiceableModel";
import ExperienceSoftWarningDialog from "../../ExperiencePopup";
import ServiceableStatusChip from "../../Statu/ServiceableStatusChip";
import { PbhRequestFileType } from "../../../../../../src/Enums/PbhRequestFileType";
import OrderTypesEnum from "../../../../../../src/Enums/OrderTypes";
import { GetRejectionQuarantinedRemoveReasonSubType } from "../../../../../../src/Enums/RemoveReasonSubType";
import { PbhRequestStatus } from "../../../../../../src/Enums/PbhRequestStatus";
import { Roles } from "../../../../../../src/Enums/Roles";
import { EightWingsStatus } from "../../../../../../src/Enums/EightWingsTabEnum";
import { OwnerType, OwnerTypeDesc } from "../../../../../../src/Enums/OwnerTypes";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const useStyles = makeStyles({
  toolbar: {
    display: "flex",
    justifyContent: "end",
    backgroundColor: "white",
  },
  defaultToolbar: {
    display: "flex",
    justifyContent: "end",
  },
});

export const EightWingsServiceableUpdate = props => {
  const [loading, setLoading] = useState(false);
  const [loadingAccept, setLoadingAccept] = useState(false);
  const [loadingReject, setLoadingReject] = useState(false);
  const { user } = useAuth();
  const [isButtonShow, setIsAButtonShow] = useState(props.serviceable?.status !== ServiceableStatu.Offered);
  const [serviceableFormDisabled, setServiceableFromDisabled] = useState(true);
  const [isCustomerFieldDisabled, setIsCustomerFieldDisabled] = useState(true);
  const [orderNumberAndTypeVisible, setOrderNumberAndTypeVisible] = useState(
    props?.serviceable?.shipmentType === Number(PbhSvcShipmentTypeEnum.DropShipment)
  );
  const [approveButtonShown, setApproveButtonShown] = useState(false);
  const [shipmentTypeList, setShipmentTypeList] = React.useState<any[]>([]);
  const [orderTypeList, setOrderTypeList] = useState<any[]>([]);

  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const aarFlyDubai = OwnerTypeDesc.find(x => x.Value == OwnerType.AARFLYDB)?.Description;
  const requestId = props.requestId;
  const isDomesticDestination = props?.requestDetail?.isDomesticDestination;

  const classes = useStyles();

  React.useEffect(() => {
    GetShipmentTypeList();
    GetOrderTypeList();
    if (user?.isCustomer === true) {
      setIsCustomerFieldDisabled(false);
    }
  }, []);
  useEffect(() => {
    setIsAButtonShow(props.serviceable?.status !== ServiceableStatu.Offered);
  }, [props.serviceable]);

  const AcceptOrRejectButtonClick = (serviceable, isApproved) => e => {
    if (AcceptOrRejectValidation(serviceable) === false) {
      return false;
    }

    if (isApproved) {
      setLoadingAccept(true);
    } else {
      setLoadingReject(true);
    }
    AcceptOrRejectServiceable(serviceable, isApproved);
  };

  const GetShipmentTypeList = () => {
    dataProvider
      .getList("ParameterDefinitions", {
        pagination: { page: 1, perPage: 500 },
        sort: { field: "id", order: "DESC" },
        filter: { parameterGroupCode__eq: PbhSvcShipmentTypeEnum.PbhSvcShipmentType },
      })
      .then(result => {
        setShipmentTypeList(result?.data ?? []);
      })
      .catch(result => console.error(result));
  };
  const GetOrderTypeList = () => {
    dataProvider
      .getList("ParameterDefinitions", {
        pagination: { page: 1, perPage: 500 },
        sort: { field: "id", order: "DESC" },
        filter: { parameterGroupCode__eq: OrderTypesEnum.OrderTypes },
      })
      .then(result => {
        setOrderTypeList(result?.data ?? []);
      })
      .catch(result => console.error(result));
  };

  const AcceptOrRejectServiceable = async (serviceable, isApproved) => {
    let requestServiceableUpdateModel: any;
    requestServiceableUpdateModel = { ...serviceable };
    requestServiceableUpdateModel.status = isApproved === true ? ServiceableStatu.Accepted : ServiceableStatu.Rejected;
    requestServiceableUpdateModel.updatedBy = user?.employeeId;
    requestServiceableUpdateModel.updatedDate = new Date();
    requestServiceableUpdateModel.rejectReasons = requestServiceableUpdateModel.rejectReasons
      ? requestServiceableUpdateModel.rejectReasons.toString()
      : "";

    if (
      requestServiceableUpdateModel.status === ServiceableStatu.Rejected &&
      (!requestServiceableUpdateModel.rejectionNote || !requestServiceableUpdateModel.rejectReasons)
    ) {
      notify(`You need to fill in Rejection Note!`, "warning");
      setLoadingReject(false);
      return;
    }
    dataProvider
      .put("eightwings/serviceableupdate", requestServiceableUpdateModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record Updated`, "success", false, true);
        setIsAButtonShow(true);
        history.push("/eightwings/" + props.eightWingsId + "/1");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => {
        setLoading(false);
        setLoadingAccept(false);
        setLoadingReject(false);
      });
  };

  const UpdateServiceableButtonClick = e => {
    UpdateServiceable(e);
  };

  const UpdateServiceable = e => {
    let serviceableUpdateModel: PbhRequestServiceablePutModel = new PbhRequestServiceablePutModel();
    serviceableUpdateModel.id = props.serviceable.id;
    serviceableUpdateModel.RequestId = props.serviceable.requestId;
    serviceableUpdateModel.Status = props.serviceable.status;
    if (orderNumberAndTypeVisible) {
      serviceableUpdateModel.OrderNumber = e.orderNumber;
      serviceableUpdateModel.OrderType = e.orderType;
    }
    serviceableUpdateModel.IsCid = e.isCid;
    serviceableUpdateModel.CidDescription = e.cidDescription;
    serviceableUpdateModel.updatedBy = user?.employeeId;
    serviceableUpdateModel.ShipmentType = Number(e.shipmentType);
    serviceableUpdateModel.updatedDate = new Date();
    if (user?.isCustomer === false) {
      serviceableUpdateModel.Awb = e.awb;
      serviceableUpdateModel.CarrierEnum = e.carrierEnum;
      serviceableUpdateModel.EstimatedDeliveryDate = e.estimatedDeliveryDate;
      serviceableUpdateModel.FlightNo = e.flightNo;
      serviceableUpdateModel.Pn = e.pn;
      serviceableUpdateModel.Sn = e.sn;
      serviceableUpdateModel.XoNo = e.xoNo;
      serviceableUpdateModel.ForwardDateToCarrier = e.forwardDateToCarrier;
      serviceableUpdateModel.RejectionNote = props.serviceable.rejectionNote;
      serviceableUpdateModel.RejectReasons = props.serviceable.rejectReasons;
    } else {
      serviceableUpdateModel.Awb = props.serviceable.awb;
      serviceableUpdateModel.CarrierEnum = props.serviceable.carrierEnum;
      serviceableUpdateModel.EstimatedDeliveryDate = props.serviceable.estimatedDeliveryDate;
      serviceableUpdateModel.FlightNo = props.serviceable.flightNo;
      serviceableUpdateModel.Pn = props.serviceable.pn;
      serviceableUpdateModel.Sn = props.serviceable.sn;
      serviceableUpdateModel.XoNo = props.serviceable.xoNo;
      serviceableUpdateModel.ForwardDateToCarrier = props.serviceable.forwardDateToCarrier;
      serviceableUpdateModel.RejectionNote = e.rejectionNote;
      serviceableUpdateModel.RejectReasons = e.rejectReasons;
    }

    if (UpdateValidation(serviceableUpdateModel)) {
      PutUpdate(serviceableUpdateModel);
    }
  };

  const UpdateValidation = (serviceablePutModel: PbhRequestServiceablePutModel) => {
    if (serviceablePutModel?.IsCid) {
      if (serviceablePutModel.CidDescription == null) {
        notify(`Cid Remark is required`, "error");
        return false;
      }
    }

    return true;
  };

  const AcceptOrRejectValidation = serviceable => {
    if (serviceable?.isCid) {
      if (serviceable.cidDescription == null) {
        notify(`Cid Remark is required`, "error");
        return false;
      }
    }
    return true;
  };

  const PutUpdate = async (putModel: PbhRequestServiceablePutModel) => {
    setLoading(true);
    dataProvider
      .put("eightwings/serviceableupdate", putModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record Updated`, "success", false, true);
        history.push("/eightwings/" + props.eightWingsId + "/1");
        setIsAButtonShow(true);
        setApproveButtonShown(false);
        setServiceableFromDisabled(true);
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const openEditableFields = e => {
    setApproveButtonShown(true);
    if (user?.isCustomer === false || user?.roles?.some(x => x == Roles.EightWings)) {
      setServiceableFromDisabled(false);
    } else {
      setIsCustomerFieldDisabled(false);
    }
  };

  const sendToPbh = () => {
    setLoading(true);
    dataProvider
      .post("eightwings/updatestatus", { id: props.eightWingsId, status: EightWingsStatus.SentToPbh })
      .then(result => {
        notify(`Sent To Pbh`, "success", false, true);
        history.push("/pbhrequestorders/" + requestId);
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => {
        setLoading(false);
      });
  };
  const cancelUpdate = e => {
    setApproveButtonShown(false);
    setServiceableFromDisabled(true);
    setIsCustomerFieldDisabled(true);
  };
  const resetValidate = form => e => {
    setTimeout(() => form?.restart?.(form?.getState?.()?.values), 500);
  };
  const onChangeShipType = e => {
    if (Number(e.target.value) === Number(PbhSvcShipmentTypeEnum.DropShipment)) {
      setOrderNumberAndTypeVisible(true);
    } else {
      setOrderNumberAndTypeVisible(false);
    }
  };
  return (
    <>
      <Form
        initialValues={props.serviceable}
        onSubmit={UpdateServiceableButtonClick}
        render={({ handleSubmit, form, values }) => (
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <Separator />
                <Grid {...gridContainerProps}>
                  <Grid container xs={12} sm={12} justifyContent="center">
                    <SectionTitle label="Serviceable Info" />
                  </Grid>
                  <Grid container xs={12} sm={12} justifyContent="flex-end" style={{ margin: 5 }}>
                    <ServiceableStatusChip serviceable={props.serviceable} />
                  </Grid>
                  <Grid container xs={12} sm={12} justifyContent="flex-end" style={{ margin: 5 }}>
                    {values?.isCid === true &&
                      !props?.requestDetail?.pbhRequestOrderFiles?.some?.(
                        x =>
                          x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Serviceable &&
                          x.pbhRequestFileTypeEnum === PbhRequestFileType.Cid
                      ) && (
                        <Chip
                          key={9999992}
                          color="primary"
                          variant="outlined"
                          label="If you have enabled the 'is Cid' field, please upload a file of type 'Cid'."
                          icon={<InfoOutlined />}
                        />
                      )}
                  </Grid>
                </Grid>
                <Separator />
                <Grid {...gridContainerProps}>
                  <Grid item xs={12} sm={5}>
                    <TextInput
                      source="pn"
                      label="PN"
                      fullWidth
                      resettable
                      variant="outlined"
                      validate={required()}
                      disabled={serviceableFormDisabled}
                    />
                    <TextInput
                      source="sn"
                      label="SN"
                      fullWidth
                      resettable
                      variant="outlined"
                      validate={required()}
                      disabled={serviceableFormDisabled}
                    />
                    <TextInput
                      source="flightNo"
                      label="Flight No"
                      fullWidth
                      resettable
                      variant="outlined"
                      disabled={serviceableFormDisabled}
                    />
                    <CustomDatetime
                      fullWidth
                      source="forwardDateToCarrier"
                      label="Forward Date To Carrier"
                      inputVariant={"dialog"}
                      variant="outlined"
                      showTime
                      validate={required()}
                      onChange={resetValidate(form)}
                      onBlur={resetValidate(form)}
                      disabled={serviceableFormDisabled}
                    />
                    <SelectInput
                      source="shipmentType"
                      label="Shipment Type"
                      choices={shipmentTypeList}
                      optionText="parameterDesc"
                      optionValue="parameterValue"
                      fullWidth
                      variant="outlined"
                      validate={required()}
                      onChange={onChangeShipType}
                      disabled={serviceableFormDisabled}
                    />
                    {orderNumberAndTypeVisible && (
                      <TextInput
                        source="orderNumber"
                        label="Order Number"
                        fullWidth
                        resettable
                        variant="outlined"
                        validate={required()}
                        disabled={serviceableFormDisabled}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <TextInput
                      source="awb"
                      label="AWB No"
                      fullWidth
                      resettable
                      variant="outlined"
                      validate={isDomesticDestination && required()}
                      disabled={serviceableFormDisabled}
                    />
                    <TextInput
                      source="xoNo"
                      label="XO Number"
                      fullWidth
                      resettable
                      variant="outlined"
                      disabled={serviceableFormDisabled}
                    />
                    <SelectInput
                      source="carrierEnum"
                      label="Carrier"
                      choices={GetCarrierType}
                      optionText="Description"
                      optionValue="Value"
                      fullWidth
                      variant="outlined"
                      validate={required()}
                      disabled={serviceableFormDisabled}
                    />
                    <CustomDatetime
                      fullWidth
                      source="estimatedDeliveryDate"
                      label="Estimated Delivery Date"
                      inputVariant={"dialog"}
                      variant="outlined"
                      showTime
                      minDate={values.forwardDateToCarrier}
                      validate={[minValue(values.forwardDateToCarrier), required()]}
                      onChange={resetValidate(form)}
                      onBlur={resetValidate(form)}
                      disabled={serviceableFormDisabled}
                    />

                    {orderNumberAndTypeVisible && (
                      <SelectInput
                        source="orderType"
                        label="Order Type"
                        choices={orderTypeList}
                        optionText="parameterDesc"
                        optionValue="parameterValue"
                        fullWidth
                        variant="outlined"
                        validate={required()}
                        disabled={serviceableFormDisabled}
                      />
                    )}
                    <BooleanInput
                      label="Received as damaged, but it will be installed on aircraft"
                      source="isCid"
                      disabled={isCustomerFieldDisabled}
                    />
                  </Grid>
                </Grid>
                <Grid {...gridContainerProps}>
                  {user?.isCustomer && !user?.roles?.includes?.(Roles.EightWings) && (
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="rejectionNote"
                        label="Rejection Note"
                        multiline
                        minRows={3}
                        inputProps={{ maxLength: 2000 }}
                        fullWidth
                        resettable
                        variant="outlined"
                        disabled={isCustomerFieldDisabled}
                      />
                    </Grid>
                  )}

                  {user?.isCustomer && !user?.roles?.includes?.(Roles.EightWings) && (
                    <Grid item xs={12} sm={5}>
                      <SelectArrayInput
                        source="rejectReasons"
                        choices={GetRejectionQuarantinedRemoveReasonSubType}
                        optionText="Description"
                        optionValue="Description"
                        disabled={isCustomerFieldDisabled}
                        fullWidth
                      />
                    </Grid>
                  )}

                  <Grid item xs={12} sm={5}>
                    {values.isCid == true && (
                      <TextInput
                        source="cidDescription"
                        label="Cid Remark"
                        multiline
                        minRows={3}
                        inputProps={{ maxLength: 2000 }}
                        fullWidth
                        resettable
                        variant="outlined"
                        disabled={isCustomerFieldDisabled}
                      />
                    )}
                  </Grid>
                </Grid>
                <Separator />
                <Toolbar {...props} placeholder="" classes={classes}>
                  {!user?.isCustomer &&
                    (props?.eightWingsStatus != EightWingsStatus.Cancel ||
                      props?.eightWingsStatus != EightWingsStatus.Reject ||
                      props?.eightWingsStatus != EightWingsStatus.SentToPbh) && (
                      <Button
                        label={loading ? "Sending!" : "Send to Pbh"}
                        size="medium"
                        variant="contained"
                        color="default"
                        onClick={sendToPbh}
                        disabled={loading}
                        style={{ margin: "8px" }}
                      >
                        {loading ? <CircularProgress size="2rem" color="secondary" /> : <RotateLeft />}
                      </Button>
                    )}
                  {user?.isCustomer && !user?.roles?.some?.(x => x == Roles.EightWings) && (
                    <>
                      <Button
                        label={loading ? "Updating!" : "Update"}
                        disabled={loading}
                        size="medium"
                        variant="contained"
                        onClick={handleSubmit}
                        style={{ margin: "8px", background: "seagreen" }}
                      >
                        {loading ? <CircularProgress size="2rem" color="secondary" /> : <Update />}
                      </Button>
                      <Button
                        label={loadingAccept ? "Serviceable is Accepted!" : "Accept Serviceable"}
                        disabled={loadingAccept || isButtonShow}
                        size="medium"
                        variant="contained"
                        onClick={AcceptOrRejectButtonClick(
                          {
                            ...props.serviceable,
                            ...{ isCid: values?.isCid, cidDescription: values?.cidDescription },
                          },
                          true
                        )}
                        style={isButtonShow ? { margin: "8px" } : { margin: "8px", background: "seagreen" }}
                      >
                        {loadingAccept ? <CircularProgress size="2rem" color="secondary" /> : <ThumbUp />}
                      </Button>
                      <Button
                        label={loadingReject ? "Serviceable is Rejected!" : "Reject Serviceable"}
                        disabled={loadingReject || isButtonShow}
                        size="medium"
                        variant="contained"
                        color="primary"
                        onClick={AcceptOrRejectButtonClick(
                          {
                            ...props.serviceable,
                            ...{
                              rejectionNote: values?.rejectionNote,
                              isCid: values?.isCid,
                              cidDescription: values?.cidDescription,
                              rejectReasons: values?.rejectReasons,
                            },
                          },
                          false
                        )}
                        style={{ margin: "8px" }}
                      >
                        {loadingReject ? <CircularProgress size="2rem" color="secondary" /> : <ThumbDownAlt />}
                      </Button>
                    </>
                  )}
                  {(!user?.isCustomer ||
                    (user?.roles?.some(x => x == Roles.EightWings) &&
                      props?.requestDetail?.ownerCode == aarFlyDubai)) &&
                    approveButtonShown === false && (
                      <Button
                        label="Edit Serviceable"
                        disabled={loading || props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled}
                        size="medium"
                        variant="contained"
                        style={isButtonShow ? { margin: "8px" } : { margin: "8px", background: "#ffc107" }}
                        onClick={openEditableFields}
                      >
                        {<Update />}
                      </Button>
                    )}
                  {approveButtonShown === true && (
                    <>
                      <Button
                        label={loading ? "Serviceable Info is updating!" : "Update Serviceable Info "}
                        disabled={loading}
                        size="medium"
                        variant="contained"
                        onClick={handleSubmit}
                        style={{ margin: "8px", background: "seagreen" }}
                      >
                        {loading ? <CircularProgress size="2rem" color="secondary" /> : <Update />}
                      </Button>
                      <Button
                        label={loading ? "Cancel!" : "Cancel"}
                        disabled={loading || props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled}
                        size="medium"
                        variant="contained"
                        color="primary"
                        onClick={cancelUpdate}
                        style={{ margin: "8px" }}
                      >
                        {<Cancel />}
                      </Button>
                    </>
                  )}
                </Toolbar>
              </Grid>
            </Grid>
          </form>
        )}
      />
      <ExperienceSoftWarningDialog data={props?.requestDetail?.experience} type={ExperienceNoteType.Serviceable} />
    </>
  );
};

export default EightWingsServiceableUpdate;
